import { motion } from "framer-motion";
import { cn } from "@/lib/utils";
import { TIME_RANGE_OPTIONS, type TimeRange } from "../mockAnalytics";

interface TimeRangeSelectorProps {
  value: TimeRange;
  onChange: (range: TimeRange) => void;
}

/** Segmented 7D / 30D / 90D pill control with a sliding active-pill indicator. */
export function TimeRangeSelector({ value, onChange }: TimeRangeSelectorProps) {
  return (
    <div
      role="tablist"
      aria-label="Analytics time range"
      className="relative inline-flex items-center rounded-lg border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-850 p-1 shadow-sm"
    >
      {TIME_RANGE_OPTIONS.map((opt) => {
        const active = opt.value === value;
        return (
          <button
            key={opt.value}
            role="tab"
            type="button"
            aria-selected={active}
            onClick={() => onChange(opt.value)}
            className={cn(
              "relative z-10 min-w-[2.75rem] rounded-md px-3 py-1.5 text-xs font-semibold transition-colors duration-200",
              active ? "text-white" : "text-slate-500 dark:text-slate-400 hover:text-slate-800 dark:hover:text-slate-200"
            )}
          >
            {active && (
              <motion.span
                layoutId="analytics-range-pill"
                className="absolute inset-0 -z-10 rounded-md bg-primary"
                transition={{ type: "spring", stiffness: 420, damping: 32 }}
              />
            )}
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}
